module.exports = function($){

    function scrolling(params){
        var args = $.extend({
            offset: 0,
            bodyclass: 'scrolling',
            clone: false
        }, params);

        var position = $(window).scrollTop();

        var f = {
            action: function(){
                let scroll = $(window).scrollTop();
                if( scroll > position ) {
                    $('body').removeClass('scrollUp').addClass('scrollDown');
                } else {
                    $('body').addClass('scrollUp').removeClass('scrollDown');
                }
                position = scroll;
                //
                if ($(window).scrollTop() > args.offset ){
                    $('body').addClass(args.bodyclass);
                } else {
                    $('body').removeClass(args.bodyclass).removeClass('scrollUp');
                }
            },
            logofixed: function(){
                if( $('.logo-fixed').length == 0 ) return;
                if( $('.section.labels-grid .logo').length == 0 ) return;
                let a1 = $('.logo-fixed').offset().top;
                let a2 = $('.section.labels-grid .logo').offset().top;
                if( a1 >= a2 ){
                    $('body').removeClass('logo-fixed-enable');
                } else {
                    $('body').addClass('logo-fixed-enable');
                }
            }
        };

        $(window).on('scroll', function(e){
            f.action();
            f.logofixed();
        });
        f.logofixed();
    }

    scrolling({
        offset: 0,
        bodyclass: 'scrolling'
    });

}
